import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuPer = () => {
  const [isOpen, setIsOpen] = useState(false)
                
  const toggle = () => {
  setIsOpen(!isOpen)
  }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
          <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
         <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
      <br />
      <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
                  <div className='card_con'>
                    <div className='wrapper'>
                      <br /><br />
                        <div className='card_area'>
                          <div className='card'>
                            <div className='meny_title'>
                                 KALLA PERSISKA DELIKATESSER
                            </div><br /><br />
                            <div className='menu_mat'>
                                Kashk-e Bademjan – aubergineröra med karamelliserad lök, mynta & valnötter.
                                <br /><br />
                                Mirza Ghasemi – grillad aubergine med tomat, vitlök & ägg.
                                <br /><br />
                                Mast-o-Khiar – persisk yoghurt med gurka, mynta & örter.
                                <br /><br />
                                Mast-o-Mousir – yoghurt med persisk schalottenlök.
                                <br /><br />
                                Shirazi-sallad med tomat, gurka, rödlök & lime.
                                <br /><br />
                                Persisk olivsallad med granatäpple & valnötter.
                                <br /><br />
                                Färska örter – basilika, mynta, persilja & koriander.
                                <br /><br />
                                Torshi – persiska picklade grönsaker.
                                <br /><br />
                                Fetaost med färska örter & valnötter.
                            </div>
                            </div>
                            <div className='card'>
                              <div className='meny_title'>
                                PERSISKT SAFFRANSRIS
                              </div><br /><br />
                              <div className='menu_mat'>
                                Zereshk Polo – saffransris med berberis, mandel & pistage.
                                <br /><br />
                                Baghali Polo – basmatiris med dill & bondbönor.
                                <br /><br />
                                Serveras med krispigt Tahdig – gyllene saffransris från botten av kastrullen.
                              </div> 
                            </div>              
                            <div className='card'>
                              <div className='meny_title'>
                                VARMA PERSISKA SPECIALITETER
                              </div><br /><br />
                            <div className='menu_mat'>
                                Joojeh Kabab – saffransmarinerad grillad kyckling med citron.
                                <br /><br />
                                Kabab Koobideh – saftiga persiska färsspett med saffran & örter.
                                <br /><br />
                                Ghormeh Sabzi – klassisk persisk örtgryta med kidneybönor, lime & örter.
                                <br /><br />
                                Fesenjan – kyckling i elegant sås av valnötter & granatäpple.
                            </div>
                            </div>
                            <div className='card'>
                            <div className='meny_title'>
                              FÄRSKA TILLBEHÖR
                                </div><br /><br />
                                <div className='menu_mat'>
                                    Grillade tomater.
                                    <br /><br />
                                    Grillad paprika.
                                    <br /><br />
                                    Persisk gurka med mynta.
                                    <br /><br />
                                    Granatäppelkärnor.
                                    <br /><br />
                                    Citron & färska örter.
                                    <br /><br />
                                    Saffransyoghurt.
                                </div>
                                </div>
                                <div className='card'>
                              <div className='meny_title'>
                                   BRÖD
                                </div><br /><br />
                                <div className='menu_mat'>
                                    Sangak
                                    <br /><br />
                                    Lavash
                                    <br /><br />
                                    Barbari
                                </div>
                                </div>
                                <div className='card'>
                                    <div className='meny_title'>
                                        PERSISKA DESSERTER
                                    </div><br /><br />
                                    <div className='menu_mat'>
                                        Saffranspudding med pistage.
                                        <br /><br />
                                        Sholeh Zard – persisk saffransdessert.
                                        <br /><br />
                                        Färska dadlar.
                                        <br /><br />
                                        Baklava med pistage & valnötter.
                                        <br /><br />
                                        Persiska småkakor.
                                        <br /><br />
                                        Färsk frukt.
                                        <br /><br />
                                    </div>
                                </div>
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuPer